<template>
    <ButtonComp
        @click="btnClick"
        class="btn-xxs no-focus"
        :icon="!active ? 'fa-check' : 'fa-times'"
        :buttonType="'Secondary'"
    >
        <template v-if="active">{{ $tm(text2) }}</template>
        <template v-else>{{ $tm(text) }}</template>
    </ButtonComp>
</template>
<script lang="ts" setup generic="TRow">
import { ButtonComp } from '@/components';
import { $tm } from '@/locize';
import type { ShootingResult } from '@/objects/generated';
import { ref } from 'vue';

const props = defineProps<{
    row: ShootingResult;
    icon?: string;
    text: string;
    text2: string;

    onClick: (row: ShootingResult, state: boolean) => void;
}>();

const active = ref<boolean>(!props.row.Disabled);

const btnClick = () => {
    active.value = !active.value;
    props.onClick(props.row, active.value);
};
</script>
